require('./bootstrap');
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import moment from 'moment';
window.moment = moment;
import Pikaday from 'pikaday';
window.Pikaday = Pikaday;
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
